import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

export const getManufacturers = async () => {
  const response = await axios.get(`${base_url}manufacturer`);
  return response.data;
};

export const createManufacturer = async (manufacturer) => {
  const response = await axios.post(`${base_url}manufacturer`, manufacturer, config);
  return response.data;
};

export const getManufacturer = async (id) => {
  const response = await axios.get(`${base_url}manufacturer/${id}`, config);
  return response.data;
};

export const updateManufacturer = async (id, payload) => {
  const response = await axios.put(
    `${base_url}manufacturer/${id}`,
    payload,
    config
  );
  return response.data;
};

export const deleteManufacturer = async (id) => {
  const response = await axios.delete(`${base_url}manufacturer/${id}`, config);
  return response.data;
};


